import { EnhancedFrontDesk } from '@/components/EnhancedFrontDesk';

export function FrontDeskTab({ hotelId }) {
  return <EnhancedFrontDesk hotelId={hotelId} />;
}
